// extracted by mini-css-extract-plugin
export default {"title_h1":"title-module--title_h1--OBFIX"};